// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"15b4311e","261":"9840a747","351":"a19a0000","480":"bf0da017","717":"623ffd7c","754":"8ae07bf7","787":"91af04ef","832":"b5fa3508"}[chunkId] + ".chunk.js";
};